/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { CustomerApiService } from './customer-api.service';
import { ConfigService } from 'src/app/service/config.service';
import { UserAccount } from 'src/models/user.types';

const ENDPOINTS = {
  cockpitSettings: '/v1/cockpit_settings',
  account: '/v5/account',
  userSettings: '/v1/settings',
} as const;

@Injectable({
  providedIn: 'root',
})
export class UserSettingsApiService {
  private customerUrl: string;

  constructor(
    private api: CustomerApiService,
    private http: HttpClient,
    private config: ConfigService,
  ) {
    this.customerUrl = this.config.appConfig.urlCustomerApi;
  }

  // COCKPIT SETTINGS -------------------------------------------------------

  /**
   * GET /v1/cockpit_settings with explicit bearer token.
   *
   * Called from `loadFeatureFlags` immediately after `jwtAuth`, before the
   * post-validation token has propagated to TokenService — so the
   * AuthInterceptor can't resolve the right token yet. Setting Authorization
   * here makes the interceptor pass the request through unchanged.
   */
  getCustomSettings(token: string): Observable<any> {
    return this.http.get(this.customerUrl + ENDPOINTS.cockpitSettings, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + token,
      }),
    });
  }

  setCustomSettings(content: any): Observable<any> {
    return this.api.post(ENDPOINTS.cockpitSettings, { settings: content });
  }

  // ACCOUNT ----------------------------------------------------------------

  getUserInfo(): Observable<any> {
    return this.api.get(ENDPOINTS.account);
  }

  updateAccount(account: UserAccount): Observable<any> {
    return this.api.post(ENDPOINTS.account, account);
  }

  // USER SETTINGS (key/value) ----------------------------------------------

  getUserSettings(key: string): Observable<any> {
    return this.api.get(ENDPOINTS.userSettings + '/' + key);
  }

  setUserSettings(key: string, value: any): Observable<string> {
    return this.api.postText(ENDPOINTS.userSettings, { key, entry: value });
  }
}
